import {ChangeDetectionStrategy, Component} from '@angular/core';
import {Store} from "@ngrx/store";
import {IRootState, selectLanguage, setLanguage} from "@app/store";
import {JsonPipe} from "@angular/common";

@Component({
  selector: 'app-lang-switcher',
  standalone: true,
  imports: [
    JsonPipe
  ],
  templateUrl: './lang-switcher.component.html',
  styleUrl: './lang-switcher.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LangSwitcherComponent {
  languages = [
    {code: 'en', name: 'EN'},
    {code: 'ru', name: 'RU'},
  ];

  currentLang = this._store.selectSignal(selectLanguage);

  constructor(private _store: Store<IRootState>) {
  }

  changeLanguage(code: string) {
    this._store.dispatch(setLanguage({language: code}));
  }
}
